import React, { Component } from "react";
import { Elements, StripeProvider } from "react-stripe-elements";
import Purchase from "./Purchase";
import { config } from "../../../config/appConfig";

class Products extends Component {
  state = {};
  render() {
    return (
      //pk_live_XcXnuMNeoD7xZZv8F4gctJ3C00ebI6kmCa
      <div>
        <StripeProvider apiKey={config.paymentkey}>
          <Elements>
            <Purchase />
          </Elements>
        </StripeProvider>
      </div>
    );
  }
}

export default Products;



// WEBPACK FOOTER //
// ./src/components/public/Purchase/Products.js